fx.ns("desktop.book.edition", class StandardView extends shared.stage.BaseView{

    constructor(board)
    {
        super(board);

        this.vmargin = 100;
        this.spaceAfterPage = fx.get("app") == "config" ? 25 : 100;
        this.spaceBeforePages = fx.get("app") == "config" ? 25 : 100;
        this.spaceAfterCover =  100;
    }

    update(animate) 
    {    
        super.update(animate);

        let screenWidth = (this.board.realWidth - 125); // 125 == topbar | TODO : get TopBar reference
        let screenHeight = this.board.realHeight;
        let screenWidthMax = screenWidth * 0.9;
        let screenHeightMax = screenHeight * 0.70;

        let childs = this.board.allChilds;

        let yPos = this.vmargin;
        let previousArea;
        let childScale;
        
        for (let i = 0; i < childs.length; i++) 
        {
            let child = childs[i];
    
            if (child instanceof shared.stage.Area)
            {  
                let ratio = child.height() / child.width();
              
                if (screenWidthMax * ratio < screenHeightMax)
                    childScale = screenWidthMax / child.width();
                else
                    childScale = screenHeightMax / child.height();
                
                child.show();
                
                this.applyPosition(child, { scale : childScale,
                                            x : (screenWidth - child.realWidth*childScale)/2 / childScale,
                                            y :  yPos / childScale }, animate);

                yPos += child.realHeight *  childScale  + (child.data.isCover ? this.spaceAfterCover : this.spaceAfterPage);

                child.removeClass("movable");

                previousArea = child;
            }
            else 
            {
                child.show();
                
                if (typeof child.horizontal == "function")
                    child.horizontal(previousArea ? previousArea.realWidth*childScale : null);

                this.applyPosition(child, { scale : 1,
                                            x : (screenWidth - child.realWidth)/2,
                                            y :  yPos }, animate);

                yPos += child.realHeight + this.spaceBeforePages;
            }
           
        }

        this.delay(this.scroll, animate ? 250 : 0);
    }

    select(area, animate)
    {
        if (!this.enabled) return;
        
        let position = this.getPosition(area);
        if (position)
        {
            let yPos = (position.y * position.scale) - (this.board.realHeight - area.realHeight*position.scale) / 2;
            this.board.scrollableContent.scroll( yPos, animate, "vertical");
        }
    }

    scroll(all)
    {
        let offset = this.board.realHeight;
        
        this._areasVisible = [];
        this._areasNotVisible = [];
        
        let viewPort = { top : this.board.scrollableContent.scrollPosition - offset, bottom : this.board.scrollableContent.scrollPosition  + this.board.scrollableContent.realHeight + offset};
        let activeArea;
        
        let childs = this.board.allChilds;


        for (let i = 0; i < childs.length; i++)
        {
            let area = childs[i];

            if (!(area instanceof shared.stage.Area)) continue;

            if (!area.initialized)
                continue;

            let position = fx.graphics.getTranslate( area, false);
            
            let visible = (position.y + area.realHeight * area.scale >= viewPort.top && position.y + area.realHeight * area.scale <= viewPort.bottom)
                            || (position.y >= viewPort.top && position.y <= viewPort.bottom)

            this._addAreaVisible(area, visible);
            
            if (visible)
            {
                 let areaCenter = (position.y + (area.realHeight * area.scale/2)) - this.board.scrollableContent.scrollPosition;
                 let surfaceCenter = this.board.scrollableContent.realHeight/2;
                 area._distanceToCenter = Math.abs(surfaceCenter - areaCenter, area.id);
            }
            
        }

        activeArea = this._areasVisible.sort(function(a, b) {   return (a._distanceToCenter - b._distanceToCenter); })[0];
        
        this.delay(this._loadUnLoadAreas, 10);
        
        return activeArea;
    }

    _loadUnLoadAreas()
    {
        for(let i = 0; i < this._areasNotVisible.length; i++)
            this._areasNotVisible[i].unload();

        for(let i = 0; i < this._areasVisible.length; i++)
            this._areasVisible[i].load();
    }

    _addAreaVisible(area, visible)
    {
        if (area instanceof shared.stage.Area)
        {
            if (visible)
            {
                this._areasVisible.add(area, true)
                this._areasNotVisible.remove(area);
            }
            else
            if (!visible)
            {
                this._areasVisible.remove(area)
                this._areasNotVisible.add(area, true);   
            }
        }
    }
});
